import { render, staticRenderFns } from "./ManageAllocationRules.vue?vue&type=template&id=76356d2e"
import script from "./ManageAllocationRules.vue?vue&type=script&lang=js"
export * from "./ManageAllocationRules.vue?vue&type=script&lang=js"
import style0 from "./ManageAllocationRules.vue?vue&type=style&index=0&id=76356d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports